import { merge } from 'lodash-es'

import enReactShop from 'locales-gen/en/shop.locales-gen.json'
import enReactShared from 'locales-gen/en/shared.locales-gen.json'

I18n.translations.en = merge(enReactShared, enReactShop)
